import { useSelector } from 'react-redux';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { RoutePaths } from '../../constants';
import styles from './Tasks.module.scss';
import { Icon, Stages, Text } from 'components';
import { selectCurrentPatientCase } from 'store/patients/selectors';

export const Tasks = () => {
  const currentPatientCase = useSelector(selectCurrentPatientCase);

  const navigate = useNavigate();

  const { id } = useParams();

  const redirectLink = id ? `${RoutePaths.PATIENTS}/${id}` : RoutePaths.PATIENTS;

  if (!currentPatientCase) return <Navigate to={redirectLink} replace={true} />;

  const goBack = () => navigate(-1);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <button className={styles.backButton} onClick={goBack}>
          <Icon name="ArrowLeft" />
        </button>
        <div className={styles.titlesWrapper}>
          <Text type="h2" className={styles.title}>
            Tasks
          </Text>
          <Text type="caption" className={styles.name}>
            {`${currentPatientCase.firstName} ${currentPatientCase.lastName}`}
          </Text>
        </div>
      </div>
      <Stages />
    </div>
  );
};
